/** @jsx jsx */
import React, { useState, useCallback, useContext } from "react"
import { Button, Flex, jsx } from "theme-ui"

import Bounce from "../../hooks/useBounce"
import useEventListener from "../../hooks/useEventListener"

import enums from "../../util/enums"

import { Context } from "../../context/MainContext"
import { ShopifyContext } from "../../context/ShopifyContext"

function CaseBuilderFooter({
  bundleSize,
  isOpen,
  colors,
  numItems,
  setIsOpen,
}) {
  const styles = {
    exit: {
      gridColumn: "1 / 7",
      gridRow: 3,
      zIndex: 1,
      padding: "0 0 20px 20px",
      display: "flex",
      alignItems: "flex-end",
      button: {
        fontFamily: "secondary",
        fontSize: "18px",
        color: "#333",
        background: "#FFFFFF",
        borderRadius: "50px",
        boxShadow: "0 0 10px 0 rgba(0,0,0,0.50)",
      },
    },
    button: {
      gridColumn: ["1 / -1", "1 / -1", "7 / -1", "7 / -1"],
      gridRow: 3,
      zIndex: 1,
      padding: "0 20px 20px 0",
      "@media screen and (max-width: 950px)": {
        marginLeft: "-50px",
      },
      "@media screen and (max-width: 640px)": {
        marginLeft: "0px",
      },
      button: {
        borderRadius: "50px",
        color: colors.heading,
        padding: "0.45em 1.2em",
        background: "#FFFFFF",
        boxShadow: "0 0 10px 0 rgba(0,0,0,0.50)",
      },
    },
  }

  const {
    store: { caseBuilderMode },
    setCaseBuilderMode,
  } = useContext(Context)
  const { checkout, addBundleToCart } = useContext(ShopifyContext)

  const [indicateAction, setIndicateAction] = useState(false)

  const closeHandler = useCallback(
    e => {
      if (e.key === "Escape" && caseBuilderMode === enums.mode.bundle)
        setCaseBuilderMode(enums.mode.view)
    },
    [setCaseBuilderMode, caseBuilderMode]
  )

  const scrollHandler = useCallback(() => {
    if (caseBuilderMode === enums.mode.bundle && isOpen === false) {
      setIndicateAction(true)
      const timeout = setTimeout(() => {
        setIndicateAction(false)
        clearTimeout(timeout)
      }, 100)
    }
  }, [setIndicateAction, caseBuilderMode, isOpen])

  useEventListener("keydown", closeHandler)
  useEventListener("mousewheel", scrollHandler)

  return (
    <React.Fragment>
      <Flex sx={styles.exit}>
        {caseBuilderMode === enums.mode.bundle && (
          <Bounce defaultScale={1.15} indicateAction={indicateAction}>
            <Button
              onClick={() => {
                setCaseBuilderMode(enums.mode.view)
                setIsOpen(false)
              }}
            >
              {"EXIT"}
            </Button>
          </Bounce>
        )}
      </Flex>

      <Flex sx={styles.button}>
        <Bounce defaultScale={1.05} disabled={numItems !== bundleSize}>
          <Button
            disabled={
              caseBuilderMode === enums.mode.bundle && numItems < bundleSize
            }
            onClick={async () => {
              if (caseBuilderMode === enums.mode.view) {
                setCaseBuilderMode(enums.mode.bundle)
                setIsOpen(false)
              }
              if (caseBuilderMode === enums.mode.bundle) {
                if (numItems !== bundleSize) return
                const cart = await addBundleToCart(checkout.bundle)

                if (cart.errors === undefined) {
                  const timeout = setTimeout(() => {
                    setCaseBuilderMode(enums.mode.view)
                    clearTimeout(timeout)
                  }, 200)
                }
              }
            }}
          >
            {caseBuilderMode === enums.mode.view && "Build Your Case"}
            {caseBuilderMode === enums.mode.bundle && (
              <span>
                {"Add to Cart "}
                <span sx={{ color: "#CCC2BA" }}>{"$60"}</span>
              </span>
            )}
          </Button>
        </Bounce>
      </Flex>
    </React.Fragment>
  )
}

export default CaseBuilderFooter
